/* ============================================================
   CARA POST — pemilih tiga cara (Bahagian 3, 2026-09-16)
   Post sekarang · Jadual · Simpan draf

   Menggantikan suis "Direct Schedule" dalam Control Panel v3.9 untuk TikTok
   (tab Schedule) DAN Facebook (keputusan user 12 Sept: SATU pemilih untuk
   kedua-dua tempat; berdenyut + Run terkunci sehingga dipilih; diingat
   per-browser). Rupa v3.9: monokrom, tiada emoji, token `.s-root`.

   RUPA SAHAJA. Nilai + simpanan hidup dalam App.jsx (`caraPost` +
   `pilihCaraPost`, kunci storan `sesaat_cara_post_v1`); pagar larian hidup
   dalam WorkspaceView (Run TikTok kalendar + Run Facebook).

   Props:
     nilai      'now' | 'schedule' | 'draft' | ''  ('' = belum dipilih → denyut)
     onPilih    (nilai) => void
     t          fungsi terjemahan pemanggil
     platform   'tiktok' | 'facebook'  — menentukan nota di bawah setiap pilihan
     kalendar   true bila tab Schedule (jadual ikut slot). Facebook di tab lain
                = tick kad → "Jadual" dikunci (tiada waktu untuk dijadualkan).
     dimatikan  true = seluruh pemilih kelabu (Showcase Only: tiada video dipost)
   ============================================================ */
import './CaraPostV39.css';

const PILIHAN = ['now', 'schedule', 'draft'];

export default function CaraPostV39({ nilai = '', onPilih, t, platform = 'tiktok', kalendar = false, dimatikan = false }) {
    const fb = platform === 'facebook';
    const belumPilih = !nilai && !dimatikan;
    const label = {
        now: t('workspace.cara.now', 'Post sekarang'),
        schedule: t('workspace.cara.schedule', 'Jadual'),
        draft: t('workspace.cara.draft', 'Simpan draf'),
    };
    const nota = {
        now: t('workspace.cara.nowNote', 'Terbit serta-merta. Satu video sahaja setiap Run.'),
        schedule: kalendar
            ? t('workspace.cara.scheduleNote', 'Robot jadualkan ikut waktu setiap slot kalendar yang ditick.')
            : t('workspace.cara.scheduleKunci', 'Hanya dari tab Schedule — kalendar yang menetapkan waktunya.'),
        draft: fb
            ? t('workspace.cara.draftNoteFb', 'Simpan sebagai draf di Content Library Facebook — semak dan terbitkan sendiri.')
            : t('workspace.cara.draftNoteTt', 'Simpan sebagai draf di TikTok — edit (letak music, dll) dan terbitkan sendiri.'),
    };
    const kunci = { now: false, schedule: !kalendar, draft: false };

    return (
        <div
            className={'s-cara' + (belumPilih ? ' s-cara--pilih' : '') + (dimatikan ? ' s-cara--mati' : '')}
            role="radiogroup"
            aria-label={t('workspace.cara.title', 'Cara post')}
        >
            {PILIHAN.map((id) => {
                const aktif = nilai === id;
                const mati = dimatikan || kunci[id];
                return (
                    <button
                        key={id}
                        type="button"
                        role="radio"
                        aria-checked={aktif}
                        disabled={mati}
                        className={'s-cara__baris' + (aktif ? ' s-cara__baris--aktif' : '')}
                        onClick={() => { if (!mati && !aktif) onPilih(id); }}
                        title={kunci[id] && !dimatikan ? nota[id] : undefined}
                    >
                        <span className="s-cara__bulat" aria-hidden="true" />
                        <span className="s-cara__txt">
                            <span className="s-cara__lbl">{label[id]}</span>
                            <span className="s-cara__nota">{nota[id]}</span>
                        </span>
                        {kunci[id] && !dimatikan && (
                            <span className="material-symbols-outlined s-cara__lock" aria-hidden="true">lock</span>
                        )}
                    </button>
                );
            })}
            {belumPilih && (
                <p className="s-cara__amaran" role="status">
                    {t('workspace.cara.pilihDulu', 'Pilih satu cara dahulu — butang Run terkunci sehingga dipilih.')}
                </p>
            )}
            {dimatikan && (
                <p className="s-hint" style={{ margin: 0 }}>
                    {t('workspace.cara.showcase', 'Showcase Only tidak memuat naik video, jadi cara post tidak terpakai.')}
                </p>
            )}
        </div>
    );
}
